export default __webpack_public_path__ + "static/media/21.6a0ab2bf.png";